module.exports = __webpack_public_path__ + "img/fankui_banner_pt.7e15808a.jpg";